module.exports = __webpack_public_path__ + "img/group_menu.d7f024dc.svg";